import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import $ from "jquery";
import _ from "lodash";
import LocalizedCountryDropdown from "./localized-country-dropdown";

import { Translate, I18n } from "react-redux-i18n";

import Form from "react-bootstrap/Form";
import { CountryDropdown } from "react-country-region-selector";

import { setAlert } from "../../../actions/alertActions";
import {
  updateAccountData,
  updatePreferences,
} from "../../../actions/accountActions";
import { getCoordsFromAddress, getCountryCode } from "../../utils/Utils";

import "../../../styles/components/account/manageAccount/Info.scss";
import pencil from "../../../styles/images/pencil.svg";

import countries from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";

countries.registerLocale(en);

class Address extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      edit: false,
      validated: false,
      zipcode_valid: false,
      address_valid: false,
      localization: "",
      place: null,

      street: "",
      city: "",
      zipCode: "",
      country: "",
      number: "",
      floor: "",
      state: "",
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnChangeZipCode = this.handleOnChangeZipCode.bind(this);
    this.handleOnChangeCountry = this.handleOnChangeCountry.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleOnChangeCountryNew = this.handleOnChangeCountryNew.bind(this);
    this.convertCountryNameEnglish = this.convertCountryNameEnglish.bind(this);
    this.countryCode = this.countryCode.bind(this);
    this.handleOnChangeCountryEnglishToCurrent =
      this.handleOnChangeCountryEnglishToCurrent.bind(this);
  }

  componentDidMount() {
    let country = this.props.locale;
    let countryCode = country.match(/^[^_]+/);
    this.loadLocale(countryCode[0]);

    this._mounted = true;
    if (this.state.zipCode !== "") {
      this.safeSetState({
        zipcode_valid: true,
      });
    }
  }

  async loadLocale(locale) {
    try {
      const localeModule = await import(
        `i18n-iso-countries/langs/${locale}.json`
      );
      countries.registerLocale(localeModule.default);
      if (this._mounted) {
        this.setState({ localization: locale });
      }
    } catch (error) {
      console.error("Failed to load language:", locale, error);
      this.setState({ localization: "en" }); // fallback
    }
  }

  countryCode() {
    let country = this.props.locale;
    let countryCode = country.match(/^[^_]+/);
    return countryCode.toString();
  }

  // Helper to find country code by matching a name in a given language
  findCountryCodeByName(languageCode, countryName) {
    const countryNames = countries.getNames(languageCode, {
      select: "official",
    });
    return Object.keys(countryNames).find(
      (code) => countryNames[code].toLowerCase() === countryName.toLowerCase()
    );
  }

  // Get country name by code and language
  getCountryName(code, languageCode) {
    return countries.getName(code, languageCode, { select: "official" });
  }

  handleOnChangeCountryEnglishToCurrent(e) {
    const matchedCode = this.findCountryCodeByName("en", e);
    return this.getCountryName(matchedCode, this.countryCode());
  }

  // This new on change was built to ensure the country dropdown and display name is following the user language
  handleOnChangeCountryNew(e) {
    this.safeSetState({ country: e });
    this.handleOnChangeCountry(this.convertLanguage(e));
  }

  convertCountryNameEnglish(e) {
    return this.convertLanguage(e);
  }

  convertLanguage(e) {
    const matchedCode = this.findCountryCodeByName(this.countryCode(), e);
    return this.getCountryName(matchedCode, "en");
  }

  static getDerivedStateFromProps(props, state) {
    if (props.accountData.places) {
      const idx = props.accountData.places.findIndex(
        (p) => p.name === props.mode
      );
      if (
        idx !== -1 &&
        !_.isEqual(props.accountData.places[idx], state.place)
      ) {
        return {
          place: props.accountData.places[idx],
          street: props.accountData.places[idx].address.street || "",
          city: props.accountData.places[idx].address.city || "",
          zipCode: props.accountData.places[idx].address.zipCode || "",
          country: props.accountData.places[idx].address.country || "",
          number: props.accountData.places[idx].address.number || "",
          floor: props.accountData.places[idx].address.floor || "",
          state: props.accountData.places[idx].address.state || "",
        };
      }
    }
    return { address: props.address };
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  handleOnChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  handleOnChangeZipCode(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });

    this.validateZipCodeComponent(e.target.value, this.state.country);
  }

  handleOnChangeCountry(country) {
    this.safeSetState({ country });
    this.validateZipCodeComponent(this.state.zipCode, country);
  }

  validateFormComponent(value, reg) {
    if (value.match(reg)) {
      return true;
    } else {
      return false;
    }
  }

  validateZipCodeComponent(zipCode, country) {
    const reg = /^\d{4}-\d{3}$/;

    if (getCountryCode(country) === "PT") {
      if (this.validateFormComponent(zipCode, reg)) {
        this.safeSetState({
          zipcode_valid: true,
        });
      } else {
        this.safeSetState({
          zipcode_valid: false,
        });
      }
    } else {
      this.safeSetState({
        zipcode_valid: true,
      });
    }
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const form = $(e.target)[0];

    if (this.state.zipcode_valid && this.state.street !== "") {
      this.safeSetState({ validated: true }, () => {
        if (!this.state.edit && form.checkValidity() !== false) {
          const idx = this.props.accountData.places.findIndex(
            (p) => p.name === this.props.mode
          );

          // check if user has place defined
          const hasPlace =
            idx !== -1 && this.props.accountData.places[idx] !== undefined;

          const { street, city, zipCode, country, number, floor, state } =
            this.state;
          const newPlace =
            idx !== -1
              ? Object.assign({}, this.props.accountData.places[idx].address, {
                  street,
                  city,
                  zipCode,
                  country,
                  countryCode: getCountryCode(country),
                  number,
                  floor,
                  state,
                })
              : {};

          // if user doesn't have a place defined or if it's defined and has been changed, get its new coordinates
          if (
            !hasPlace ||
            !_.isEqual(newPlace, this.props.accountData.places[idx].address)
          )
            getCoordsFromAddress(
              { street, city, zipCode, country, number, state },
              this.state.country,
              this.props.brand?.tokenMapBox
            ).then((res, i) => {
              // after getting coords, prepare the patch packet with updated data
              let patch = {
                referencePlaces: Array.from(this.props.accountData.places),
              };

              if (res) {
                const hasResult = res.data.features.some((f) => {
                  if (
                    f.place_type.includes("address") ||
                    f.place_type.includes("poi") ||
                    f.place_type.includes("place")
                  ) {
                    if (idx !== -1) {
                      patch.referencePlaces[idx] = {
                        name: this.props.mode,
                        address: {
                          street,
                          city,
                          zipCode,
                          country,
                          countryCode: getCountryCode(country),
                          number,
                          floor,
                          state,
                        },
                        geometry: {
                          type: "Point",
                          coordinates: f.center,
                        },
                      };
                    } else {
                      patch.referencePlaces.push({
                        name: this.props.mode,
                        address: {
                          street,
                          city,
                          zipCode,
                          country,
                          countryCode: getCountryCode(country),
                          number,
                          floor,
                          state,
                        },
                        geometry: {
                          type: "Point",
                          coordinates: f.center,
                        },
                      });
                    }

                    this.props.setAlert(
                      I18n.t("configurationKeys_updateSuccessful"),
                      "primary"
                    );
                    return true;
                  } else return false;
                });

                if (hasResult) {
                  axios
                    .patch("/api/private/users/referencePlaces", patch, {
                      cancelToken: new CancelToken((c) => (this.cancel = c)),
                    })
                    .then((res) => {
                      if (res.data) {
                        this.safeSetState({ edit: false }, () => {
                          this.props.updateAccountData(
                            this.props.accountData.internationalPrefix,
                            this.props.accountData.phone
                          );
                          this.props.setAlert(
                            I18n.t("editAccount_profileUpdatedSuccessfully"),
                            "primary"
                          );
                        });
                      }
                    })
                    .catch((err) =>
                      this.props.setAlert(
                        I18n.t(err.response.data.message),
                        "danger"
                      )
                    );
                } else {
                  this.props.setAlert(I18n.t("address_notFound"), "danger");
                  return;
                }
              }
            });
        }
      });
    } else {
      this.safeSetState({ edit: true });

      if (!this.state.zipcode_valid) {
        if (!this.state.edit) {
          this.props.setAlert(
            I18n.t("backOffice_network_request_verifyZipCode_alert"),
            "danger"
          );
        }
      }
      if (this.state.street === "") {
        this.props.setAlert(
          I18n.t("backOffice_network_request_verifyAddress_alert"),
          "danger"
        );
      }
    }
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="info" className="evio-container">
        <div className="top-bar">
          <p className="title">
            <Translate
              value={
                this.props.mode === "home"
                  ? this.props.isCompany
                    ? "address_homeAddress_headquarters"
                    : "address_homeAddress"
                  : this.props.isCompany
                  ? "address_homeAddress_secondary"
                  : "address_workAddress"
              }
            />
          </p>
          <button
            type="submit"
            form={`${this.props.mode}-address-form`}
            className={this.state.edit ? "save-btn" : "clear"}
            onClick={() => {
              this.safeSetState((prevState) => ({
                edit: !prevState.edit,
              }));
            }}
          >
            {this.state.edit ? (
              <Translate value="editAccount_saveButton" />
            ) : (
              <img src={pencil} alt={I18n.t("editAccount_editLabel")} />
            )}
          </button>
        </div>
        <Form
          id={`${this.props.mode}-address-form`}
          validated={this.state.validated}
          noValidate
          onSubmit={this.handleOnSubmit}
        >
          <Form.Group className="info-field">
            <Form.Label>
              <Translate value="address_address" />
            </Form.Label>
            <Form.Control
              type="text"
              name="street"
              value={
                this.state.street && this.state.street !== ""
                  ? this.state.street
                  : this.state.edit
                  ? ""
                  : "-"
              }
              onChange={this.handleOnChange}
              disabled={!this.state.edit}
              required
            />
          </Form.Group>
          <Form.Group className="info-field">
            <Form.Label>
              <Translate value="addAddress_number" />
            </Form.Label>
            <Form.Control
              type="text"
              name="number"
              value={
                this.state.number && this.state.number !== ""
                  ? this.state.number
                  : this.state.edit
                  ? ""
                  : "-"
              }
              onChange={this.handleOnChange}
              disabled={!this.state.edit}
            />
          </Form.Group>
          <Form.Group className="info-field">
            <Form.Label>
              <Translate value="addAddress_floor" />
            </Form.Label>
            <Form.Control
              type="text"
              name="floor"
              value={
                this.state.floor && this.state.floor !== ""
                  ? this.state.floor
                  : this.state.edit
                  ? ""
                  : "-"
              }
              onChange={this.handleOnChange}
              disabled={!this.state.edit}
            />
          </Form.Group>

          <Form.Group className="info-field">
            <Form.Label>
              <Translate value="backOffice_network_forms_contractStateAddress" />
            </Form.Label>
            <Form.Control
              type="text"
              name="state"
              value={
                this.state.state && this.state.state !== ""
                  ? this.state.state
                  : this.state.edit
                  ? ""
                  : "-"
              }
              onChange={this.handleOnChange}
              disabled={!this.state.edit}
            />
          </Form.Group>
          <Form.Group className="info-field">
            <Form.Label>
              <Translate value="address_city" />
            </Form.Label>
            <Form.Control
              type="text"
              name="city"
              value={
                this.state.city && this.state.city !== ""
                  ? this.state.city
                  : this.state.edit
                  ? ""
                  : "-"
              }
              onChange={this.handleOnChange}
              disabled={!this.state.edit}
            />
          </Form.Group>
          <Form.Group className="info-field">
            <Form.Label>
              <Translate value="accountDetails_country" />
            </Form.Label>
            {this.state.edit ? (
              <div className="select-container">
                <Form.Control
                  as={CountryDropdown}
                  value={
                    this.state.country && this.state.country !== ""
                      ? this.state.country
                      : this.state.edit
                      ? ""
                      : "-"
                  }
                  onChange={(country) => this.handleOnChangeCountry(country)}
                  disabled={false}
                  required
                />
              </div>
            ) : (
              <Form.Control
                value={
                  this.state.country && this.state.country !== ""
                    ? this.state.country
                    : this.state.edit
                    ? ""
                    : "-"
                }
                disabled={true}
              />
            )}
          </Form.Group>
          <Form.Group className="info-field">
            <Form.Label>
              <Translate value="address_postCode" />
            </Form.Label>
            <Form.Control
              type="text"
              name="zipCode"
              value={
                this.state.zipCode && this.state.zipCode !== ""
                  ? this.state.zipCode
                  : this.state.edit
                  ? ""
                  : "-"
              }
              onChange={this.handleOnChangeZipCode}
              disabled={!this.state.edit || !this.state.country}
              required
            />
          </Form.Group>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  accountData: state.account.accountData,
  isCompany: state.account.isCompany,
  locale: state.i18n.locale,
});

export default connect(mapStateToProps, {
  setAlert,
  updateAccountData,
  updatePreferences,
})(Address);
